import { Typography, TypographyProps } from '@mui/material';

import { DateFormat, i18nFormat } from 'utils/date.utils';

import { useLocale } from 'hooks/useLocale';

import SeperatorDate from './SeperatorDate';

interface Props extends TypographyProps {
  zonedStartDate: Date;
  updatedZonedEndDate: Date;
}

//Component to get right format for single day

//Thu 7 Dec 9:00PM - Thu 7 Dec 11:30PM = single day
//Thu 7 Dec - 9:00PM - 11:30PM

//Thu 7 Dec 9:00PM - Fri 8 Dec 6:00AM = single day
//Thu 7 Dec - 9:00PM - 6:00AM

const SingleDayDateTime = ({
  zonedStartDate,
  updatedZonedEndDate,
  ...props
}: Props) => {
  const { locale } = useLocale();

  return (
    <Typography
      variant="extraSmall"
      {...props}
      sx={[
        {
          color: 'global01.400',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {i18nFormat(zonedStartDate, DateFormat.ShortDayDateTime[locale], locale)}
      <SeperatorDate key={1} />
      {i18nFormat(zonedStartDate, DateFormat.ShortTime, locale)}&nbsp;-&nbsp;
      {i18nFormat(updatedZonedEndDate, DateFormat.ShortTime, locale)}
    </Typography>
  );
};

export default SingleDayDateTime;
